import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { araRegelungenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface AraRegelung {
    art: number;
    text: string;
}

export const defaultAraRegelung: AraRegelung = {
    art: 0,
    text: '',
};

export function useAraRegelungenAsOptions(): SelectOption[] {
    const araRegelungen = useSelector(araRegelungenSelector);

    return React.useMemo<SelectOption[]>(() => {
        return araRegelungen.map(
            (araRegelung) => ({ value: araRegelung.art.toString(), label: araRegelung.text } as SelectOption),
        );
    }, [araRegelungen]);
}

export async function addAraRegelung(araRegelung: AraRegelung): Promise<void> {
    return callApi<void>(Controller.araRegelung + '/add', { araRegelung });
}

export async function updateAraRegelung(araRegelung: AraRegelung): Promise<void> {
    return callApi<void>(Controller.araRegelung + '/update', { araRegelung });
}

export async function deleteAraRegelung(araRegelung: AraRegelung): Promise<void> {
    return callApi<void>(Controller.araRegelung + '/update', { araRegelung });
}
